import React, { useState, useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import AddImage from "../../Global Functions/addImage";
import { editCity, viewCity } from "../../Redux/Actions/settingsActions";
import { useDispatch } from "react-redux";
import TextInput from "../../Global Functions/textInput";
import { MdClose } from "react-icons/md";
import "./editCity.css";

const EditCity = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [cityData, setCityData] = useState({
    is_popular: false,
    is_vr_home_visit_available: false, // Added VR toggle field
    image: "",
    id: id,
    description: "",
    position: 0,
    city_name: "",
  });

  const [isTrue, setIsTrue] = useState(false); // Popular toggle
  const [isVRTrue, setIsVRTrue] = useState(false); // VR toggle
  const [loading, setLoading] = useState(true);

  // Fetch city details on load
  useEffect(() => {
    async function fetchCity() {
      setLoading(true);
      try {
        const response = await dispatch(viewCity(id));
        if (response && response.statusCode === 200 && response.data) {
          const data = response.data;
          setCityData({
            is_popular: data.is_popular || false,
            is_vr_home_visit_available: data.is_vr_home_visit_available || false, // Added VR field
            image: data.image || "",
            id: data._id,
            description: data.description || "",
            position: data.position || 0,
            city_name: data.city_name || "",
          });
          setIsTrue(data.is_popular || false);
          setIsVRTrue(data.is_vr_home_visit_available || false); // Initialize VR toggle
        } else {
          setCityData({
            is_popular: false,
            is_vr_home_visit_available: false,
            image: "",
            id: id,
            description: "",
            position: 0,
            city_name: "",
          });
          setIsTrue(false);
          setIsVRTrue(false);
        }
      } catch (err) {
        setCityData({
          is_popular: false,
          is_vr_home_visit_available: false,
          image: "",
          id: id,
          description: "",
          position: 0,
          city_name: "",
        });
        setIsTrue(false);
        setIsVRTrue(false);
      }
      setLoading(false);
    }
    fetchCity();
  }, [dispatch, id]);

  const popularToggle = (event) => {
    event.preventDefault();
    const updatedStatus = !isTrue;
    setIsTrue(updatedStatus);
    setCityData((prevData) => ({ ...prevData, is_popular: updatedStatus }));
  };

  const vrToggle = (event) => {
    event.preventDefault();
    const updatedStatus = !isVRTrue;
    setIsVRTrue(updatedStatus);
    setCityData((prevData) => ({ ...prevData, is_vr_home_visit_available: updatedStatus }));
  };

  const handleImageUpload = async (event) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);
    if (responseUrl) {
      setCityData((prevData) => ({ ...prevData, image: responseUrl }));
    }
  };

  const handleChange = (e) => {
    setCityData({ ...cityData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await dispatch(editCity(cityData));
      if (response.statusCode === 200) {
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) {
    return (
      <MainLayout>
        <div style={{ padding: "20px" }}>Loading city data...</div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div
        style={{
          paddingTop: "10px",
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          minWidth: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 20px",
            alignItems: "center",
          }}
        >
          <h1>Edit City - {cityData.city_name}</h1>
          <button onClick={() => navigate(-1)} className="button-class">
            Go Back
          </button>
        </div>
        <form>
          <div className="flex-container flex-justify-between gap-10" style={{ padding: "0 3%" }}>
            {/* Popular Toggle */}
            <div style={{ width: "48%" }}>
              <div style={{ alignItems: "center", gap: "20px" }}>
                <div
                  style={{
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  {isTrue ? "Is Popular" : "Not Popular"}
                </div>
                <label
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "50px",
                    height: "26px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isTrue}
                    onChange={popularToggle}
                    style={{
                      opacity: 0,
                      width: 0,
                      height: 0,
                      position: "absolute",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: isTrue ? "#08a600" : "#ccc",
                      borderRadius: "26px",
                      transition: "0.4s",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      left: isTrue ? "24px" : "2px",
                      top: "2px",
                      width: "22px",
                      height: "22px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      transition: "0.4s",
                      boxShadow: "0 0 2px rgba(0,0,0,0.2)",
                    }}
                  />
                </label>
              </div>
            </div>

            {/* VR Home Visit Toggle */}
            <div style={{ width: "48%" }}>
              <div style={{ alignItems: "center", gap: "20px" }}>
                <div
                  style={{
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  {isVRTrue ? "VR Available" : "VR Not Available"}
                </div>
                <label
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "50px",
                    height: "26px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isVRTrue}
                    onChange={vrToggle}
                    style={{
                      opacity: 0,
                      width: 0,
                      height: 0,
                      position: "absolute",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: isVRTrue ? "#08a600" : "#ccc",
                      borderRadius: "26px",
                      transition: "0.4s",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      left: isVRTrue ? "24px" : "2px",
                      top: "2px",
                      width: "22px",
                      height: "22px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      transition: "0.4s",
                      boxShadow: "0 0 2px rgba(0,0,0,0.2)",
                    }}
                  />
                </label>
              </div>
            </div>
          </div>

          <div style={{ display: "flex", marginTop: "1rem", padding: "0 3%", gap: "10px" }}>
            <div style={{ width: "50%" }}>
              <TextInput
                placeholder="Enter Description"
                label="Description"
                name="description"
                value={cityData.description}
                onChange={handleChange}
              />
            </div>

            <div style={{ width: "50%" }}>
              <TextInput
                placeholder="Enter Popular Key"
                label="Popular Key"
                name="position"
                type="number"
                value={cityData.position}
                onChange={handleChange}
              />
            </div>
          </div>

          <div style={{ display: "flex", marginTop: "1rem", padding: "0 3%", gap: "10px" }}>
            <div style={{ width: "100%" }}>
              <span className="span-class">Upload City Image</span>
              <input
                style={{ display: "none" }}
                type="file"
                name="icon"
                id="icon"
                onChange={(event) => handleImageUpload(event)}
              />
              <label className="label-class-image" htmlFor="icon">
                Click To Upload Image
              </label>

              {cityData.image && (
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginTop: "10px",
                  }}
                >
                  <img
                    src={cityData.image}
                    alt="City"
                    style={{
                      maxWidth: "100%",
                      borderRadius: "8px",
                      display: "block",
                    }}
                  />
                  <button
                    type="button"
                    onClick={() =>
                      setCityData((prevData) => ({ ...prevData, image: "" }))
                    }
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                      border: "none",
                      borderRadius: "50%",
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                      zIndex: 20,
                      boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                    }}
                    aria-label="Remove image"
                  >
                    <MdClose size={20} color="red" />
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="flex-end margin-h-10" gapLeft="10px" style={{ padding: "20px 3%" }}>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="button-class-white"
            >
              Cancel
            </button>
            <button onClick={handleSubmit} className="button-class">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditCity;
